import React, { useState, useEffect } from "react";
import { colors } from "../../../themes/Colors";

const ToastNotification = ({ display, title, mainTitle, message, width }) => {
  const [open, setOpen] = useState(false);
  const [move, setMove] = useState(false);

  useEffect(() => {
    if (display) {
      setOpen(true);
    } else if (!display) {
      setMove(false);
      setTimeout(() => {
        setOpen(false);
      }, 1000);
    }
  }, [display]);
  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setMove(true);
      }, 1200);
    }
  }, [open]);
  return (
    <div
      style={{
        position: "absolute",
        width: move ? "100%" : open ? 200 : 0,
        height: open ? (move ? 250 : 200) : 0,
        top: 0,
        right: 0,
        transition: "all 0.8s",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 400,
      }}
    >
      <div
        style={{
          height: move ? 200 : open ? 150 : 0,
          width: move ? "80%" : open ? 150 : 0,
          backgroundColor: colors.white,
          borderRadius: move ? 10 : 20,
          transition: "all 0.6s",
          WebkitBoxShadow: "-2px 5px 20px 1px #00000080",
          opacity: open ? 1 : 0,
        }}
      >
        {move ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <div
              style={{
                width: width > 599 ? "97%" : "80%",
                height: "80%",
                borderStyle: "solid",
                borderWidth: 5,
                borderColor:
                  title === "SUCCESS" ? colors.greenLight : colors.orangeDark,
                borderRadius: 10,
              }}
            >
              <div
                style={{
                  marginLeft: 20,
                  marginTop: 20,
                  marginBottom: 5,
                  fontWeight: "bold",
                  fontSize: 20,
                  color: colors.secondaryDarkBlue,
                  height: move ? 22 : 0,
                  transition: "all 1s",
                  opacity: move && open ? 1 : 0,
                }}
              >
                {mainTitle}
              </div>
              <div
                style={{
                  marginLeft: 20,
                  height: move ? "100%" : 0,
                  transition: "all 1s",
                  opacity: move && open ? 1 : 0,
                  fontSize: width > 599 ? 16 : 13,
                  color: colors.greenDark,
                }}
              >
                {message}
              </div>
            </div>
          </div>
        ) : open ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <div
              style={{
                width: "80%",
                height: "80%",
                borderStyle: "solid",
                borderWidth: 5,
                borderColor:
                  title === "SUCCESS" ? colors.greenLight : colors.orangeDark,
                borderRadius: 20,
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div>
                <img
                  alt="icon"
                  src={require("../../../images/icons/infoDarkBlue.png")}
                  style={{ height: 70 }}
                />
              </div>
              <div
                style={{
                  //   marginLeft: 20,
                  marginTop: 10,
                  marginBottom: 5,
                  fontWeight: "bold",
                  fontSize: 15,
                  color: colors.secondaryDarkBlue,
                }}
              >
                {title}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};
export default ToastNotification;
